import Phaser from "phaser"

export default class Prizes extends Phaser.Scene {

    preload() {
        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));
        this.load.image("prizes-background", require('./assets/prizesV2.png'));
        
        this.load.image("leaderboard-backBtn-border", require('../../assets/back-button.png'));
    }
    create() {
        this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
        this.soundConfig();
        this.add.image(0, 0, "prizes-background").setOrigin(0, 0);
        this.backBtn = this.add.image(100, 100, "leaderboard-backBtn-border").setScale(0.2);
            this.backBtn.setInteractive();
            this.backBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('Introduction');
            });

            // this.add.text((1080 / 2 ), 60, "Prizes", { fontFamily: 'Rockridge', fontSize: 75, color: '#F05B45' }).setFixedSize(300,80)

            this.add.text((1080 / 2), 100, "Prizes", {
                color: '#F05B45',
                boundsAlignH: "center", boundsAlignV: "middle",
                font: '600 75px Rockridge'
            }).setOrigin(0.5, 0.5).setAlign('center').setFixedSize(300,80);
    }
    soundConfig(){
        this.clickSound.mute = !this.game.config.soundSetting;
    }
    update() {

    }

}